import React from "react";
import { QRCodeSVG } from "qrcode.react";
import "@fontsource/jetbrains-mono/800.css";
import "@fontsource/crimson-text/400-italic.css";
import type { AotdDay } from "../../printsApi";
import type { PrintEdition } from "../../printProducts";
import { printDate, printQrUrl, printQuote } from "./faceData";
import "./sheetFace.css";

// The poster (size 50) or wall card (size 21), as the print file draws it: art 84% of the sheet, the
// number and date on top, author (and their quote) and site on the sides, title, emojis, edition box
// and QR below.

export interface SheetFaceProps {
  day: AotdDay;
  art: string;
  size: 50 | 21;
  edition?: PrintEdition;
  /** drawn width in px; everything inside scales with it */
  width?: number;
}

export const SheetFace: React.FC<SheetFaceProps> = ({ day, art, size, edition = "print", width = 900 }) => {
  const orig = edition === "original";
  const emojis = day.emojis ?? [];
  const quote = printQuote(day);
  return (
    <div className={`pf-sheet${orig ? " pf-sheet--orig" : ""}`} data-size={size} style={{ width }}>
      <div className="pf-m pf-top pf-small">
        <span>art of the day<b className="pf-no">#{day.number}</b></span>
        <span>{printDate(day.date)}</span>
      </div>
      <div className="pf-m pf-side pf-side--left pf-author">
        <span>
          by{day.authorEmoji ? <span className="pf-emoji">{day.authorEmoji}</span> : " "}.<b>{day.createdBy}</b>
        </span>
        {quote && <span className="pf-q">{quote}</span>}
      </div>
      <div className="pf-m pf-side pf-side--right pf-small pf-site">n450s.com</div>
      <div className="pf-m pf-qr">
        <QRCodeSVG value={printQrUrl(day)} level="M" marginSize={0} fgColor="#2b2b2b" bgColor="transparent" />
      </div>
      <div className="pf-frame">
        {orig && <div className="pf-frame-foil" aria-hidden="true" />}
        <div className="pf-art"><img src={art} alt="" /></div>
      </div>
      <div className="pf-foot">
        <h2 className="pf-title">{day.title}</h2>
        <div className="pf-edition">{orig ? "original · 1 of 1" : "print 001"}</div>
        {emojis.length > 0 && <div className="pf-day-emojis">{emojis.join("")}</div>}
      </div>
    </div>
  );
};

export default SheetFace;
